import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setObjectType } from '../../actions/objectType';
import { ObjectType } from '../../components/ObjectType';
import { LEGAL_CHECK_FORM_URL_WITH_SOURCE } from '../../constants/legalCheckFormUrl';
import { EObjectType } from '../../constants/objectType';
import { IApplicationState } from '../../types/redux';
import { trackGoToFormClick } from '../PageContainer/trackings';

export const ObjectTypeContainer: React.FC = () => {
  const dispatch = useDispatch();
  const objectType = useSelector((state: IApplicationState) => state.objectType.value);
  const handleOnChange = React.useCallback(
    (value: EObjectType) => {
      dispatch(setObjectType(value));
    },
    [dispatch],
  );
  const handleRedirectToLegalCheckForm = React.useCallback(() => {
    // На этом месте не может не быть objectType, пока его нет кнопка "Продолжить" задизейблена
    // oxlint-disable-next-line typescript/no-non-null-assertion
    trackGoToFormClick(objectType!);
    window.location.assign(`${LEGAL_CHECK_FORM_URL_WITH_SOURCE}&objectType=${objectType}`);
  }, [objectType]);

  return <ObjectType onChange={handleOnChange} onClick={handleRedirectToLegalCheckForm} selectedValue={objectType} />;
};

ObjectTypeContainer.displayName = 'ObjectTypeContainer';
